export const REQUEST_EMPLOYEE_CATEGORY = 'REQUEST_EMPLOYEE_CATEGORY';
export const FETCH_EMPLOYEE_CATEGORY = 'FETCH_EMPLOYEE_CATEGORY';

export const REQUEST_OFFERS = "REQUEST_OFFERS";
export const FETCH_OFFERS = "FETCH_OFFERS";

export const OPEN_SIGNUP = 'OPEN_SIGNUP';
export const CLOSE_SIGNUP = "CLOSE_SIGNUP";

export const LOGOUT_USER = 'LOGOUT'

export const REQUEST_LOGIN_USER = 'REQUEST_LOGIN_USER'
export const LOGIN_USER = 'LOGIN_USER'

export const MOBILE_NAV = "MOBILE_NAV";

export const REQUEST_CLEANER = "REQUEST_CLEANER";
export const GET_CLEANER = "GET_CLEANER";

export const REQUEST_CARPENTER = "REQUEST_CARPENTER";
export const GET_CARPENTER = "GET_CARPENTER";

export const REQUEST_ELECTRICIAN = "REQUEST_ELECTRICIAN";
export const GET_ELECTRICIAN = "GET_ELECTRICIAN";

export const REQUEST_REVIEW = "REQUEST_REVIEW";
export const GET_REVIEW = "GET_REVIEW";

export const GET_USER = 'GET_USER';
export const GET_USER_ERROR = "GET_USER_ERROR"

export const REQUEST_EMPLOYEES = 'REQUEST_EMPLOYEES';
export const FETCH_EMPLOYEES = 'FETCH_EMPLOYEES';

export const REQUEST_REVIEWS = 'REQUEST_REVIEWS';
export const FETCH_REVIEWS = 'FETCH_REVIEWS';

export const REQUEST_CREATE_REVIEW = 'REQUEST_CREATE_REVIEW';
export const CREATE_REVIEW = 'CREATE_REVIEW';

export const REQUEST_CREATE_REPLY = 'REQUEST_CREATE_REPLY';
export const CREATE_REPLY = 'CREATE_REPLY';

export const REQUEST_FULL_SERVICE = 'REQUEST_FULL_SERVICE';
export const FETCH_FULL_SERVICE = 'FETCH_FULL_SERVICE';

export const GET_BASIC_CART = "GET_BASIC_CART";

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_CART = "CLEAR_CART";
export const DELETE_SERVICE_FROM_CART = "DELETE_SERVICE_FROM_CART";

export const REQUEST_DETAIL_CART = "REQUEST_DETAIL_CART";
export const GET_DETAIL_CART = "GET_DETAIL_CART";

export const REQUEST_APPLY_COUPON = "REQUEST_APPLY_COUPON";
export const APPLY_COUPON = "APPLY_COUPON";

export const REQUEST_CONTACT_US = "REQUEST_CONTACT_US";
export const CONTACT_US = "CONTACT_US";

export const REQUEST_VERIFY_NUMBER = "REQUEST_VERIFY_NUMBER";
export const VERIFY_NUMBER = "VERIFY_NUMBER";

export const REQUEST_VERIFY_OTP = "REQUEST_VERIFY_OTP";
export const VERIFY_OTP = "VERIFY_OTP";

export const REQUEST_UPDATE_SIGNUP_PROFILE = "REQUEST_UPDATE_SIGNUP_PROFILE";
export const UPDATE_SIGNUP_PROFILE = "UPDATE_SIGNUP_PROFILE";

export const REQUEST_FETCH_ORDERS = "REQUEST_FETCH_ORDERS";
export const FETCH_ORDERS = "FETCH_ORDERS";

export const REQUEST_FETCH_ORDER = "REQUEST_FETCH_ORDER";
export const FETCH_ORDER = "FETCH_ORDER";


export const SEARCH_SERVICES = "SEARCH_SERVICES";
export const CLEAR_SEARCH = "CLEAR_SEARCH";

export const REQUEST_GET_HIRING = "REQUEST_GET_HIRING";
export const GET_HIRING = "GET_HIRING";

// Plan To Remove
export const AUTHENTICATION_LOADING = "AUTHENTICATION_LOADING";

export const REQUEST_SERVICE_RECOMMANDATION_BASIC = "REQUEST_SERVICE_RECOMMANDATION_BASIC"
export const FETCH_SERVICE_RECOMMANDATION_BASIC = "FETCH_SERVICE_RECOMMANDATION_BASIC"

export const REQUEST_SERVICE_RECOMMANDATION_DETAILED = "REQUEST_SERVICE_RECOMMANDATION_DETAILED"
export const FETCH_SERVICE_RECOMMANDATION_DETAILED = "FETCH_SERVICE_RECOMMANDATION_DETAILED"

export const REQUEST_ADD_TO_CART_FROM_RECOMMENDED = 'REQUEST_ADD_TO_CART_FROM_RECOMMENDED'
export const ADD_TO_CART_FROM_RECOMMENDED = 'ADD_TO_CART_FROM_RECOMMENDED'

export const CHANGE_THEME = "CHANGE_THEME";
export const REFRESH_THEME = "REFRESH_THEME";

export const FETCH_CSRF = "FETCH_CSRF";

